import dayjs from "dayjs";
import { _CHECK } from ".";
import { openAlertPopup } from "../../views/Layout";

//     false - 이메일 형식 오류
export const EmailCheck = email => {
  let expText = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;

  if (!expText.test(email)) {
    return false;
  } else {
    return true;
  }
};

// 비밀번호 형식 체크
// return value :
//     true - 비밀번호 형식
//     false - 비밀번호 형식 오류
export const PwdCheck = password => {
  // let expText = /^.*(?=^.{8,16}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/
  // let expText = /^.*(?=^.{8,16}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[-=~!@#$%^&*()_+]).*$/
  const expText = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{5,}$/;

  if (!expText.test(password)) {
    return false;
  } else {
    return true;
  }
};

// 비밀번호 체크 (자릿수 + 형식)
export const PwdValidate = (password, rePassword) => {
  if (password.length == 0) {
    openAlertPopup("비밀번호를 입력하세요.");
    return false;
  }

  if (rePassword.length == 0) {
    openAlertPopup("2차 비밀번호를 입력하세요.");
    return false;
  }

  if (password.trim() === rePassword.trim()) {
    if (
      password.trim().length < 5 ||
      password.trim().length > 16 ||
      !_CHECK.PwdCheck(password.trim())
    ) {
      openAlertPopup("비밀번호를 5~16자의 알파벳, 숫자를 조합하여 입력하세요.");
      return false;
    } else {
      return true;
    }
  } else {
    openAlertPopup("비밀번호와 2차 비밀번호가 일치하지 않습니다.");
    return false;
  }
};

// input type='number' maxLength check
// input 속성에 onChange 지정하고 사용
// onChange={(e)=>maxLengthCheck(e, maxLength)}
export const maxLengthCheck = (e, maxLength) => {
  if (e.target.value.length > maxLength) {
    e.target.value = e.target.value.slice(0, maxLength);
    return false;
  }
  return true;
};

// 문자열 전화번호 포멧 변경
// 01012341234 -> 010-1234-1234
export const stringToTelNo = no => {
  if (no) {
    const replaceNo = no.replace("-", "");
    return replaceNo
      .replace(/[^0-9]/g, "")
      .replace(
        /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
        "$1-$2-$3"
      )
      .replace("--", "-");
  }
};

// 한자리 숫자 앞자리 "0"표시
// 1 -> 01
export const checkNum10 = param => {
  let returnParam = parseInt(param).toString();

  if (returnParam < 10) {
    returnParam = "0" + returnParam;
  }

  return returnParam;
};

// 시간 오전, 오후 변환
export const ckeckAmPm = hour => {
  let orgHour = hour;
  let returnAmPm = orgHour < 12 ? "오전" : "오후";

  return returnAmPm;
};

// 병원명이 5글자 이상인경우 3글자+...표시
export const checkName = (checkString, maxLength, cutLengthParam) => {
  let rtnValue = checkString;
  let cutLength = 3;

  if (cutLength) {
    cutLength = cutLengthParam;
  }

  if (rtnValue.length >= maxLength) {
    rtnValue = rtnValue.substring(0, cutLength) + "...";
  }

  return rtnValue;
};

// 날짜 요일정보 가져오기
export const getWeekday = sDate => {
  let yy = parseInt(sDate.substr(0, 4), 10);
  let mm = parseInt(sDate.substr(4, 2), 10);
  let dd = parseInt(sDate.substr(6, 2), 10);

  let d = new Date(yy, mm - 1, dd);
  let weekday = new Array(7);
  weekday[0] = "일";
  weekday[1] = "월";
  weekday[2] = "화";
  weekday[3] = "수";
  weekday[4] = "목";
  weekday[5] = "금";
  weekday[6] = "토";

  return weekday[d.getDay()];
};

// 날짜형식 포멧 변경
// 20240101 -> 2024.01.01
export const inputDotInDate = date => {
  const paramDate = date.toString();
  let returnDate;

  if (paramDate.length == 8) {
    returnDate =
      paramDate.substring(0, 4) +
      "." +
      paramDate.substring(4, 6) +
      "." +
      paramDate.substring(6, 8);
  } else if (paramDate.length == 6) {
    returnDate =
      paramDate.substring(0, 2) +
      "." +
      paramDate.substring(2, 4) +
      "." +
      paramDate.substring(4, 6);
  }

  return returnDate;
};

// 영문(영어) 체크
export const checkEngAll = str => {
  const regExp = /[a-zA-Z]/g; // 영어
  if (regExp.test(str)) {
    return true;
  } else {
    return false;
  }
};

// 데이터 유효성 검사
// 한글, 영어, 숫자, 특수문자 구분 정규식 모음
export const checkNum = /[0-9]/;
export const checkEng = /[a-zA-Z]/;
export const checkSpc = /[~!@#$%^&*()_+|<>?:{}]/;
export const checkKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

// 영어 대문자와 소문자는 다음과도 같이 구분할 수 있다.
export const checkEnga = /[a-z]/;
export const checkEngA = /[A-Z]/;

export default {
  EmailCheck,
  PwdCheck,
  PwdValidate,
  checkNum10,
};

// 날짜 포멧 변경
export const changeDateFormat = postDate => {
  const returnDate =
    postDate.length == 8
      ? dayjs(postDate).format("YYYY-MM-DD")
      : dayjs(postDate).format("YYYY-MM-DD HH:mm");

  return returnDate;
};

// 24시간 규칙 -> 12시간 규칙으로 변경
export const checkHour12 = hourData => {
  if (parseInt(hourData) > 12) {
    return checkNum10(parseInt(hourData) - 12);
  } else {
    return checkNum10(hourData);
  }
};

// e => t.target
// onChange 입력값 이모지 제거
export const removeEmojis = e => {
  const regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  if (regex.test($(e).val())) {
    let strVal = $(e).val().replace(regex, "");
    return strVal;
  } else {
    return e.value;
  }
};

// 날짜형식 맞는지 체크
export const checkDateNow = appTime => {
  if (dayjs(appTime).format("YYYYMMDD") === dayjs().format("YYYYMMDD")) {
    return true;
  } else {
    return false;
  }
};

// 전화번호 유효성 검사
export const telValidator = args => {
  const msg = "유효하지 않는 전화번호입니다.";
  // IE 브라우저에서는 당연히 var msg로 변경
  // /^(070|02|0[3-9]|01[016789]{1}[0-9]{1})[0-9]{3,4}[0-9]{4}$/

  if (args.length > 6) {
    // if (/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}/.test(args)) {
    if (
      /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70))([0-9]{3}|[0-9]{4})[0-9]{4}$/.test(
        args
      )
    ) {
      return true;
    } else {
      return false;
    }
  }
  // alert(msg);
  return false;
};

// 공통 체크로직
// name (한글 or 영어)
// number (지역번호 + 3or4자리 + 4자리 숫자)
// korEngNum (한글, 영어, 숫자)
// faxNum (2~4자리 + 3~4자리 + 4자리 숫자)
// storeName (한글, 영어, 숫자, 일부 특수문자<[,],(,),+,-,_,·>)
export const checkData = (check, data) => {
  switch (check) {
    case "name": {
      if (/^[가-힣a-zA-Z]+$/.test(data)) {
        return true;
      } else {
        return false;
      }
    }
    case "number": {
      // if (/^(070|02|0[3-9]{2}|01[016789]{1})[0-9]{3,4}[0-9]{4}$/.test(data)) {
      if (
        /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70|10|16|17|19))([0-9]{3}|[0-9]{4})[0-9]{4}$/.test(
          data
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
    case "korEngNum": {
      // if (/^[ㄱ-ㅎ가-힣a-zA-Z0-9\[\]\(\)\,\\]+$/.test(data)) {
      if (/^[가-힣a-zA-Z0-9\[\]\(\)\,\\]+$/.test(data)) {
        return true;
      } else {
        return false;
      }
    }

    case "faxNum": {
      if (/^[0-9]{2,4}[0-9]{3,4}[0-9]{4}$/.test(data)) {
        return true;
      } else {
        return false;
      }
    }
    case "storeName": {
      // *영어나 한글이 꼭 포함되어야 함
      if (/^[가-힣a-zA-Z(0-9\[\]\(\)\,\+\-\_\+\·\\)]+$/.test(data)) {
        if (/^[(0-9\[\]\(\)\,\+\-\_\+\·\\)]+$/.test(data)) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
      // data가 전부 특수문자면 err
      // data가 전부 단모음이면 err
    }

    case "birth": {
      if (!data || data == "" || data.trim().length < 8) {
        return false;
      } else if (
        dayjs(data).format("YYYYMMDD") > dayjs().format("YYYYMMDD") ||
        dayjs(data).format("YYYYMMDD") <
          dayjs(
            (
              parseInt(dayjs().format("YYYYMMDD").substring(0, 4)) - 120
            ).toString() + dayjs().format("YYYYMMDD").substring(4, 8)
          ).format("YYYYMMDD")
      ) {
        return false;
      } else if (
        parseInt(data.substring(4, 6)) > 12 ||
        parseInt(data.substring(4, 6)) < 1
      ) {
        return false;
      } else if (
        parseInt(data.substring(6, 8)) > 31 ||
        parseInt(data.substring(6, 8)) < 0
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
